module.exports = __webpack_public_path__ + "media/svg/ckeck-eac51e6e.svg";